"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7022],{

/***/ 19590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64182);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledSection = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].section.withConfig({
    componentId: "sc-4934dd0c-0"
})(_templateObject());
var AgeField = function(param) {
    var _showTooltip = param.showTooltip, showTooltip = _showTooltip === void 0 ? true : _showTooltip, isProductWithHospitalServices = param.isProductWithHospitalServices, hasSubmitAttempt = param.hasSubmitAttempt;
    var values = (0,formik__WEBPACK_IMPORTED_MODULE_4__.useFormikContext)().values;
    var scale = values.scale;
    var hasPartner = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_3__.includes)(scale, _constants__WEBPACK_IMPORTED_MODULE_6__/* .SCALES_WITH_MULTIPLE_ADULTS */ .rn);
    var tooltip = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__.P, {
            children: [
                "Your age helps us calculate your Australian Government Rebate (AGR)",
                isProductWithHospitalServices && " and any Youth Discount",
                ". The AGR applied to your policy is based on the oldest member’s age on your policy."
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .FormikField */ .Ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                label: "My age",
                name: "age",
                size: "auto",
                tooltip: showTooltip && tooltip
            }, hasSubmitAttempt ? {
                touched: hasSubmitAttempt
            } : {}), {
                input: {
                    inputMode: "numeric",
                    pattern: "[0-9]*"
                },
                type: "text"
            })),
            hasPartner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .FormikField */ .Ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                label: "My partner’s age",
                name: "partnerAge",
                input: {
                    inputMode: "numeric",
                    pattern: "[0-9]*"
                }
            }, hasSubmitAttempt ? {
                touched: hasSubmitAttempt
            } : {}), {
                type: "text"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AgeField);


/***/ }),

/***/ 41052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64182);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10453);
/* harmony import */ var _utils_get_income_tier_options__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2001);








var THIRD_PARTY = _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].URLS.THIRD_PARTY */ .Z.URLS.THIRD_PARTY;
var IncomeTierField = function(param) {
    var _showExplainer = param.showExplainer, showExplainer = _showExplainer === void 0 ? true : _showExplainer, showTooltip = param.showTooltip;
    var values = (0,formik__WEBPACK_IMPORTED_MODULE_2__.useFormikContext)().values;
    var incomeType = values.incomeType;
    var incomeTierOptions = (0,_utils_get_income_tier_options__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        incomeType: incomeType
    });
    var allOptions = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(incomeTierOptions).concat([
        {
            text: "I don’t want to claim the rebate",
            value: _constants__WEBPACK_IMPORTED_MODULE_4__/* .INCOME_TIER_NONE */ .yF
        }, 
    ]);
    var explanation = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.P, {
        variant: "small14",
        children: [
            "This is your income for",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
                to: THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE,
                children: "Medicare Levy Surcharge"
            }),
            " purposes, which is different to taxable income.",
            " "
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FormikField */ .Ub, {
                label: incomeType === _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].INCOME_TYPE.SINGLE */ .Z.INCOME_TYPE.SINGLE ? "My annual income" : "Combined annual income",
                name: "incomeTier",
                size: "auto",
                inputVariant: [
                    "button",
                    "fullWidth"
                ],
                type: "dropdown",
                options: allOptions,
                tooltip: showTooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                    children: explanation
                })
            }),
            showExplainer && explanation
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IncomeTierField);


/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_can_choose_income_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78569);
/* harmony import */ var _utils_get_income_type_options__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26456);









var IncomeTypeTooltip = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
    children: [
        "Household income type refers to the people in the household, not the income. Even if there’s only one income in your household, unless you’ve selected “single cover”, your income type would be “Couple or family — Incl. single parent”",
        " "
    ]
});
var IncomeTypeField = function() {
    var ref = (0,formik__WEBPACK_IMPORTED_MODULE_3__.useFormikContext)(), setFieldTouched = ref.setFieldTouched, setFieldValue = ref.setFieldValue, values = ref.values;
    var scale = values.scale;
    var helperText = !(0,_utils_can_choose_income_type__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(scale) && "You have chosen ".concat((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.replace)("-", " ", scale), " cover above, so your income type would be couple or family.");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FormikField */ .Ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, helperText && {
        helperText: helperText
    }), {
        inputVariant: [
            "button",
            "fullWidth"
        ],
        label: "Household income type",
        name: "incomeType",
        onBlur: function() {
            return setFieldTouched("incomeType", true, false);
        },
        // @ts-expect-error - Automatic, Please fix when editing this file
        onChange: function(val) {
            return setFieldValue("incomeType", val);
        },
        options: (0,_utils_get_income_type_options__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(scale),
        size: "auto",
        tooltip: IncomeTypeTooltip,
        type: "radioGroup"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IncomeTypeField);


/***/ }),

/***/ 4187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_get_frequency_options__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26089);





var frequencyOptions = (0,_utils_get_frequency_options__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    endText: "ly",
    format: lodash_fp__WEBPACK_IMPORTED_MODULE_2__.toLower
});
var PaymentFrequencyField = function(param) {
    var _label = param.label, label = _label === void 0 ? "I want to pay" : _label, location = param.location, variant = param.variant;
    if ((location === null || location === void 0 ? void 0 : location.pathname) === "/tax") {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FormikField */ .Ub, {
        inputVariant: [
            variant,
            "button",
            "fullWidth"
        ],
        label: label,
        name: "frequency",
        options: frequencyOptions,
        size: "auto",
        type: "dropdown"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PaymentFrequencyField);


/***/ }),

/***/ 57593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10453);
/* harmony import */ var _utils_get_scale_options__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94562);







var defaultScaleOptions = (0,_utils_get_scale_options__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    endText: "cover",
    format: lodash_fp__WEBPACK_IMPORTED_MODULE_2__.toLower
});
var mapScaleToIncomeType = function(scale) {
    if (scale === _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].SCALE.SINGLE */ .Z.SCALE.SINGLE) {
        return _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].INCOME_TYPE.SINGLE */ .Z.INCOME_TYPE.SINGLE;
    }
    return _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].INCOME_TYPE.COUPLE */ .Z.INCOME_TYPE.COUPLE;
};
var ScaleField = function(param) {
    var _label = param.label, label = _label === void 0 ? "I’m after" : _label, product = param.product;
    var ref;
    var setFieldValue = (0,formik__WEBPACK_IMPORTED_MODULE_3__.useFormikContext)().setFieldValue;
    var selectable = product === null || product === void 0 ? void 0 : (ref = product.scales) === null || ref === void 0 ? void 0 : ref.selectable;
    var scaleOptions = selectable ? (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map)(function(value) {
        return {
            text: "".concat((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.lowerCase)(value), " cover"),
            value: value
        };
    }, selectable) : defaultScaleOptions;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FormikField */ .Ub, {
        // @ts-expect-error - Automatic, Please fix when editing this file
        onChange: function(param) {
            var value = param.target.value;
            setFieldValue("incomeType", mapScaleToIncomeType(value));
            setFieldValue("scale", value);
        },
        inputVariant: [
            "button",
            "fullWidth"
        ],
        label: label,
        name: "scale",
        options: scaleOptions,
        size: "auto",
        type: "dropdown"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScaleField);


/***/ }),

/***/ 80501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10453);




var StateField = function(param) {
    var _label = param.label, label = _label === void 0 ? "I live in" : _label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FormikField */ .Ub, {
        inputVariant: [
            "button",
            "fullWidth"
        ],
        label: label,
        name: "state",
        options: _ahm_constants__WEBPACK_IMPORTED_MODULE_3__/* ["default"].STATE_OPTIONS */ .Z.STATE_OPTIONS,
        size: "auto",
        type: "dropdown"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StateField);


/***/ }),

/***/ 87022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pricing_drawer; }
});

// UNUSED EXPORTS: PricingDrawerForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/utils/get-updated-fields/index.ts
var get_updated_fields = __webpack_require__(48906);
// EXTERNAL MODULE: ./src/client/utils/submit-updated-refine-fields/index.ts
var submit_updated_refine_fields = __webpack_require__(98170);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/utils/build-submit-handler/index.ts


var buildSubmitHandler = function(param) {
    var actions = param.actions, formValues = param.formValues, initialValues = param.initialValues, customer = param.customer;
    var scale = customer.scale, rebate = customer.rebate;
    var updatedFields = (0,get_updated_fields/* default */.Z)({
        formValues: formValues,
        initialValues: initialValues,
        scale: scale
    });
    (0,submit_updated_refine_fields/* default */.Z)({
        actions: actions,
        rebate: rebate,
        scale: scale,
        updatedFields: updatedFields
    });
    actions.customer.changeHasRefinedPrice(true);
    actions.drawer.closeDrawer();
};
/* harmony default export */ var build_submit_handler = (buildSubmitHandler);

// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/age-field/index.tsx
var age_field = __webpack_require__(19590);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/excess-toggle/index.tsx





var hospitalExcessToOptions = function(hospitalExcess) {
    var excessForOptions = ui.EXCESS_TYPES;
    var unavailableExcessTypes = (0,fp.difference)(ui.EXCESS_TYPES, hospitalExcess);
    return (0,fp.map)(function(value) {
        var isDisabled = (0,fp.includes)(value, unavailableExcessTypes);
        return {
            isDisabled: isDisabled,
            text: "$".concat(value),
            value: "".concat(value)
        };
    })(excessForOptions);
};
var ExcessToggle = function(param) {
    var isExcessApplicable = param.isExcessApplicable, hospitalExcess = param.hospitalExcess;
    if (!isExcessApplicable) {
        return null;
    }
    var tooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Tooltip */.u, {
        children: [
            "An excess is an upfront lump sum payment that you agree to pay towards the cost of your hospital stay or day surgery. You can reduce your health insurance premium by opting for a $",
            (0,fp.max)(hospitalExcess),
            " hospital excess per",
            "person (up to a maximum of $",
            (0,fp.max)(hospitalExcess) * 2,
            " per couple/family per Membership Year)."
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FormikField */.Ub, {
        label: "I want my hospital excess to be",
        name: "hospitalExcess",
        size: "auto",
        inputVariant: [
            "button",
            "fullWidth"
        ],
        type: "dropdown",
        options: hospitalExcessToOptions(hospitalExcess),
        tooltip: tooltip
    });
};
ExcessToggle.defaultProps = {
    match: null
};
/* harmony default export */ var excess_toggle = (ExcessToggle);

// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/income-tier-field/index.tsx
var income_tier_field = __webpack_require__(41052);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/income-type-field/index.tsx
var income_type_field = __webpack_require__(86708);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/payment-frequency-field/index.tsx
var payment_frequency_field = __webpack_require__(4187);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/scale-field/index.tsx
var scale_field = __webpack_require__(57593);
// EXTERNAL MODULE: ./src/client/selectors/select-excess-toggle-values/index.ts
var select_excess_toggle_values = __webpack_require__(58400);
// EXTERNAL MODULE: ./src/client/selectors/select-is-excess-toggle-applicable/index.ts
var select_is_excess_toggle_applicable = __webpack_require__(78260);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/state-field/index.tsx
var state_field = __webpack_require__(80501);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/components/customer-form/index.tsx















var schemaForErrorSummary = {
    age: {
        linkPhrases: [
            "age"
        ]
    },
    partnerAge: {
        linkPhrases: [
            "partner’s age"
        ]
    }
};
var CustomerForm = function(param) {
    var hasSubmitAttempt = param.hasSubmitAttempt, hospitalExcess = param.hospitalExcess, isExcessApplicable = param.isExcessApplicable, isProductWithHospitalServices = param.isProductWithHospitalServices, location = param.location, match = param.match, product = param.product, showIncomeOptions = param.showIncomeOptions;
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, handleSubmit = ref.handleSubmit, isSubmitting = ref.isSubmitting, touched = ref.touched;
    var ref1 = (0,react.useState)(false), showErrorSummary = ref1[0], setShowErrorSummary = ref1[1];
    (0,react.useEffect)(function() {
        if (isSubmitting && !(0,fp.isEmpty)(errors)) {
            setShowErrorSummary(true);
        }
    }, [
        errors,
        isSubmitting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showErrorSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ErrorSummary */.Xg, {
                errors: errors,
                schema: schemaForErrorSummary,
                touched: touched
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm.Form, {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(scale_field/* default */.Z, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(state_field/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_frequency_field/* default */.Z, {
                        location: location
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(age_field/* default */.Z, {
                        hasSubmitAttempt: hasSubmitAttempt,
                        isProductWithHospitalServices: isProductWithHospitalServices
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(excess_toggle, {
                        hospitalExcess: hospitalExcess,
                        isExcessApplicable: isExcessApplicable,
                        match: match
                    }),
                    showIncomeOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(income_type_field/* default */.Z, {}),
                    showIncomeOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(income_tier_field/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        md: true,
                        sm: true,
                        xs: true,
                        df: true,
                        lg: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                            type: "submit",
                            onClick: handleSubmit,
                            children: "Update"
                        })
                    })
                ]
            })
        ]
    });
};
CustomerForm.defaultProps = {
    location: null,
    match: null,
    product: {},
    showIncomeOptions: true
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, props) {
    var ref;
    return {
        hospitalExcess: (0,select_excess_toggle_values/* default */.Z)(state),
        isExcessApplicable: (0,select_is_excess_toggle_applicable/* default */.ZP)(state, props),
        location: state === null || state === void 0 ? void 0 : (ref = state.router) === null || ref === void 0 ? void 0 : ref.location,
        products: state.product.data
    };
};
/* harmony default export */ var customer_form = ((0,es/* connect */.$j)(mapStateToProps)(CustomerForm));

// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/components/footer/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  padding: 1rem 0;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    margin: 0;\n    padding-right: 2rem;\n    width: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n\n  @media (min-width: ",
        ") {\n    font-size: initial;\n    margin-bottom: 1rem;\n  }\n\n  li {\n    display: flex;\n    justify-content: space-between;\n    padding: 1rem 0;\n\n    &:first-of-type {\n      padding-top: 0;\n    }\n\n    &.youthDiscount {\n      border-top: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-58a61241-0"
})(_templateObject());
var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-58a61241-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var StyledCustomerVariables = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-58a61241-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey30;
});
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-58a61241-3"
})(_templateObject3());
var StyledTooltip = (0,styled_components_browser_esm["default"])(ahm_ui/* Tooltip */.u).withConfig({
    componentId: "sc-58a61241-4"
})(_templateObject4());

// EXTERNAL MODULE: ./src/client/components/pricing-drawer/constants/index.ts
var constants = __webpack_require__(64182);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/utils/get-youth-discount-percentage-from-ages/index.ts
var get_youth_discount_percentage_from_ages = __webpack_require__(73943);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
// EXTERNAL MODULE: ./src/client/selectors/select-age-bracket/index.ts + 1 modules
var select_age_bracket = __webpack_require__(6504);
// EXTERNAL MODULE: ./src/client/models/agr/index.ts
var agr = __webpack_require__(99997);
// EXTERNAL MODULE: ./src/client/utils/get-income-tier-options/index.ts
var get_income_tier_options = __webpack_require__(2001);
// EXTERNAL MODULE: ./src/client/selectors/select-raw-price/index.ts
var select_raw_price = __webpack_require__(13303);
;// CONCATENATED MODULE: ./src/client/selectors/select-rebate-percentage-raw/index.ts






// @ts-expect-error - Automatic, Please fix when editing this file
var selectCustomerFormValues = function(state, values) {
    return values;
};
/* harmony default export */ var select_rebate_percentage_raw = ((0,reselect_es.createSelector)([
    selectCustomerFormValues,
    select_raw_price/* default */.Z
], function(customerFormValues, rawPrice) {
    var age = customerFormValues.age, incomeTier = customerFormValues.incomeTier, incomeType = customerFormValues.incomeType, partnerAge = customerFormValues.partnerAge;
    var ageBracket = (0,select_age_bracket/* getAgrBracketFromAges */.b)([
        age,
        partnerAge
    ]);
    var incomeTierAsNumber = (0,fp.toNumber)(incomeTier);
    if ((0,fp.isNaN)(incomeTierAsNumber)) {
        return 0;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    var value = (0,get_income_tier_options/* default */.Z)({
        incomeType: incomeType
    })[incomeTierAsNumber].value;
    return agr/* default.getPercentage */.Z.getPercentage({
        ageBracket: ageBracket,
        incomeTier: value,
        rebate: true
    }, {
        useFutureEffectiveDate: rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.useFutureEffectiveDate
    });
}));

;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/components/footer/index.tsx











var WHAT_IS_AGR = ahm_constants/* default.URLS.HELP.WHAT_IS_AGR */.Z.URLS.HELP.WHAT_IS_AGR;
var agrTooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, {
    children: [
        "The",
        " ",
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
            to: WHAT_IS_AGR,
            inNewTab: true,
            children: "AGR"
        }),
        " ",
        "applied to your policy is based on the oldest member’s age on your policy."
    ]
});
var Footer = function(param) {
    var handleClose = param.handleClose, isProductWithHospitalServices = param.isProductWithHospitalServices;
    var ref = (0,formik_esm.useFormikContext)(), submitForm = ref.submitForm, values = ref.values;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var age = values.age, partnerAge = values.partnerAge, scale = values.scale;
    var rebatePercentage = (0,es/* useSelector */.v9)(function(state) {
        return select_rebate_percentage_raw(state, values);
    });
    var hasPartner = (0,fp.includes)(scale, constants/* SCALES_WITH_MULTIPLE_ADULTS */.rn);
    var youthDiscountPercentage = (0,fp.flow)(fp.compact, (0,fp.map)(fp.toInteger), get_youth_discount_percentage_from_ages/* default */.Z)([
        age,
        hasPartner && partnerAge
    ]) || 0;
    var YOUTH_DISCOUNT = ahm_constants/* default.URLS.HELP.YOUTH_DISCOUNT */.Z.URLS.HELP.YOUTH_DISCOUNT;
    var youthDiscountTooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, {
        children: [
            youthDiscountPercentage > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Based on your age of ",
                    age,
                    hasPartner && partnerAge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " and your partner’s age of ",
                            partnerAge
                        ]
                    }),
                    ".",
                    " "
                ]
            }) : "Hospital price excludes any Youth Discount. ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                to: YOUTH_DISCOUNT,
                inNewTab: true,
                children: "Learn more about Youth Discount"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomerVariables, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                children: [
                                    "Australian Government Rebate\xa0",
                                    agrTooltip
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Strong */.cK, {
                                children: [
                                    rebatePercentage,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    isProductWithHospitalServices && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "youthDiscount",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Youth Discount ",
                                    youthDiscountTooltip
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Strong */.cK, {
                                children: [
                                    youthDiscountPercentage,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                        onClick: submitForm,
                        type: "submit",
                        children: "Update"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/form-validation/lib/main.js
var main = __webpack_require__(91843);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/schema/index.ts




var integer = main.messageDefaults.integer, minAge = main.messageDefaults.minAge, minAgePartner = main.messageDefaults.minAgePartner, required = main.messageDefaults.required, validAge = main.messageDefaults.validAge;
var pricingDrawerSchema = (0,index_esm/* object */.Ry)({
    age: (0,index_esm/* number */.Rx)().typeError(integer).required("Enter your age").integer(integer).min(16, minAge).max(120, validAge),
    frequency: (0,index_esm/* string */.Z_)().required(required),
    hospitalExcess: (0,index_esm/* string */.Z_)().required(required),
    incomeTier: (0,index_esm/* string */.Z_)().required(required),
    incomeType: (0,index_esm/* string */.Z_)().required(required),
    partnerAge: (0,index_esm/* number */.Rx)().typeError(integer).nullable().when("scale", {
        is: function(value) {
            return !(0,fp.includes)(value, [
                src.SCALE.SINGLE,
                src.SCALE.SINGLE_PARENT
            ]);
        },
        then: function(rule) {
            return rule.required("Enter your partner’s age").integer(integer).min(16, minAgePartner).max(120, validAge);
        }
    }),
    rebate: (0,index_esm/* string */.Z_)().required(required),
    scale: (0,index_esm/* string */.Z_)().required(required),
    state: (0,index_esm/* string */.Z_)().required(required)
});
/* harmony default export */ var schema = (pricingDrawerSchema);

// EXTERNAL MODULE: ./src/client/selectors/select-current-drawer/index.ts
var select_current_drawer = __webpack_require__(84466);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/selectors/select-customer-form-initial-values/index.ts
var select_customer_form_initial_values = __webpack_require__(33628);
;// CONCATENATED MODULE: ./src/client/components/pricing-drawer/index.tsx

function pricing_drawer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-margin-top: 5rem;\n"
    ]);
    pricing_drawer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var StyledScrollMarginDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d94cfaa3-0"
})(pricing_drawer_templateObject());
var PricingDrawer = function(param) {
    var actions = param.actions, customer = param.customer, _drawer = param.// @ts-expect-error - Automatic, Please fix when editing this file
    drawer, drawer = _drawer === void 0 ? null : _drawer, initialValues = param.initialValues, isProductWithHospitalServices = param.isProductWithHospitalServices, _match = param.// @ts-expect-error - Automatic, Please fix when editing this file
    match, match = _match === void 0 ? null : _match, _showIncomeOptions = param.showIncomeOptions, showIncomeOptions = _showIncomeOptions === void 0 ? true : _showIncomeOptions, _product = param.product, product = _product === void 0 ? {} : _product;
    var formRef = (0,react.useRef)(null);
    var closeDrawer = function() {
        actions.drawer.closeDrawer();
    };
    var drawerFooter = /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {
        handleClose: closeDrawer,
        isProductWithHospitalServices: isProductWithHospitalServices
    });
    var isOpen = drawer === ui.DRAWER_IDS.CHANGE_DETAILS;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
        enableReinitialize: true,
        validationSchema: schema,
        initialValues: initialValues,
        onSubmit: function(values) {
            build_submit_handler({
                actions: actions,
                customer: customer,
                formValues: values,
                initialValues: initialValues
            });
        },
        children: function(param) {
            var errors = param.errors, isSubmitting = param.isSubmitting, submitCount = param.submitCount;
            if (isSubmitting && !(0,fp.isEmpty)(errors)) {
                // @ts-expect-error - Automatic, Please fix when editing this file
                formRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Drawer */.dy, {
                title: "Change details",
                isOpen: isOpen,
                toggleMenu: actions.drawer.closeDrawer,
                footer: drawerFooter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollMarginDiv, {
                    ref: formRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_form, {
                        isProductWithHospitalServices: isProductWithHospitalServices,
                        hasSubmitAttempt: Boolean(submitCount),
                        match: match,
                        product: product,
                        showIncomeOptions: showIncomeOptions
                    })
                })
            });
        }
    });
};
var pricing_drawer_mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        drawer: (0,select_current_drawer/* default */.Z)(state),
        initialValues: (0,select_customer_form_initial_values/* default */.Z)(state),
        scale: (0,select_customer/* default */.Z)(state).scale
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            drawer: (0,redux/* bindActionCreators */.DE)(drawer/* default */.Z, dispatch)
        }
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var pricing_drawer = ((0,es/* connect */.$j)(pricing_drawer_mapStateToProps, mapDispatchToProps)(PricingDrawer));



/***/ }),

/***/ 33628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64182);
/* harmony import */ var _utils_get_member_age__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59218);
/* harmony import */ var _selectors_select_customer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34112);








/* harmony default export */ __webpack_exports__["Z"] = ((0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)(_selectors_select_customer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, function(customer) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.omitBy)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isNull, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)([
        "frequency",
        "hospitalExcess",
        "incomeTier",
        "incomeType",
        "productType",
        "rebate",
        "scale",
        "state"
    ], customer)), {
        age: (0,_utils_get_member_age__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            customer: customer,
            relationship: _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__.RELATIONSHIP.CLIENT
        }) || "",
        incomeTier: customer.rebate === false ? _constants__WEBPACK_IMPORTED_MODULE_3__/* .INCOME_TIER_NONE */ .yF : customer.incomeTier,
        partnerAge: (0,_utils_get_member_age__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            customer: customer,
            relationship: _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__.RELATIONSHIP.SPOUSE
        }) || "",
        productType: customer.productType === _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__.PRODUCT_TYPE.COMBINED ? _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__.PRODUCT_TYPE.PACKAGE : customer.productType
    }));
}));


/***/ }),

/***/ 48906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64182);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96852);



var INCOME_TIER = _constants__WEBPACK_IMPORTED_MODULE_1__/* .FIELD_NAMES.INCOME_TIER */ .mA.INCOME_TIER, PARTNER_AGE = _constants__WEBPACK_IMPORTED_MODULE_1__/* .FIELD_NAMES.PARTNER_AGE */ .mA.PARTNER_AGE;
var reduceWithIndex = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_0__.reduce);
var INITIAL_VALUE = {};
var getUpdatedFields = function(param) {
    var initialValues = param.initialValues, formValues = param.formValues, scale = param.scale;
    var exceptionList = [
        INCOME_TIER,
        PARTNER_AGE
    ];
    var scaleForPartnerAge = (formValues === null || formValues === void 0 ? void 0 : formValues.scale) || scale;
    var updatedFormValues = reduceWithIndex(function(accumulator, formValue, key) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        var hasValueChanged = formValue !== initialValues[key];
        if (hasValueChanged && !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(key, exceptionList)) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.set)(key, formValue, accumulator);
        }
        if (key === INCOME_TIER && formValue !== _constants__WEBPACK_IMPORTED_MODULE_1__/* .INCOME_TIER_NONE */ .yF && hasValueChanged) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.set)(key, formValue, accumulator);
        }
        if (key === INCOME_TIER && formValue === _constants__WEBPACK_IMPORTED_MODULE_1__/* .INCOME_TIER_NONE */ .yF && initialValues.rebate === true) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.set)(key, formValue, accumulator);
        }
        if (key === PARTNER_AGE && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scaleForPartnerAge, _constants__WEBPACK_IMPORTED_MODULE_1__/* .SCALES_WITH_MULTIPLE_ADULTS */ .rn) && hasValueChanged) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.set)(key, formValue, accumulator);
        }
        return accumulator;
    }, INITIAL_VALUE)(formValues);
    return updatedFormValues;
};
/* harmony default export */ __webpack_exports__["Z"] = (getUpdatedFields);


/***/ }),

/***/ 84466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null);
// @ts-expect-error - Automatic, Please fix when editing this file
var selectCurrentDrawer = getOrNull("drawer.openDrawerId");
/* harmony default export */ __webpack_exports__["Z"] = (selectCurrentDrawer);


/***/ }),

/***/ 26089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var _models_price_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28614);



var getFrequencyOptions = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _format = ref.format, format = _format === void 0 ? lodash_fp__WEBPACK_IMPORTED_MODULE_0__.identity : _format, endText = ref.endText;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(frequency) {
        return {
            text: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.join)("", [
                format(_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.PAYMENT_FREQUENCY_LABEL[frequency]),
                endText
            ]),
            value: frequency
        };
    }, _models_price_constants__WEBPACK_IMPORTED_MODULE_2__.PAYMENT_FREQUENCY_OPTIONS);
};
/* harmony default export */ __webpack_exports__["Z"] = (getFrequencyOptions);


/***/ }),

/***/ 26456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _can_choose_income_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78569);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10453);





var disableSingleIncomeTypeOption = function(option) {
    return option.value === _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].INCOME_TYPE.SINGLE */ .Z.INCOME_TYPE.SINGLE ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, option), {
        disabled: true
    }) : option;
};
var getIncomeTypeOptions = function() {
    var scale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SCALE.SINGLE */ .Z.SCALE.SINGLE;
    return (0,_can_choose_income_type__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(scale) ? _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].INCOME_TYPE_OPTIONS */ .Z.INCOME_TYPE_OPTIONS : (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(disableSingleIncomeTypeOption, _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].INCOME_TYPE_OPTIONS */ .Z.INCOME_TYPE_OPTIONS);
};
/* harmony default export */ __webpack_exports__["Z"] = (getIncomeTypeOptions);


/***/ }),

/***/ 94562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var _models_customer_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28280);



var getScaleOptions = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _format = ref.format, format = _format === void 0 ? lodash_fp__WEBPACK_IMPORTED_MODULE_0__.identity : _format, endText = ref.endText;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(scale) {
        return {
            text: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
                format(_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.SCALE_LABEL[scale]),
                endText
            ]).join(" "),
            value: scale
        };
    }, _models_customer_constants__WEBPACK_IMPORTED_MODULE_2__.SCALE_OPTIONS);
};
/* harmony default export */ __webpack_exports__["Z"] = (getScaleOptions);


/***/ }),

/***/ 98170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64182);
/* harmony import */ var _get_date_of_birth_from_age__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9805);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96852);





var AGE = _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .FIELD_NAMES.AGE */ .mA.AGE, HOSPITAL_EXCESS = _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .FIELD_NAMES.HOSPITAL_EXCESS */ .mA.HOSPITAL_EXCESS, INCOME_TIER = _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .FIELD_NAMES.INCOME_TIER */ .mA.INCOME_TIER, PARTNER_AGE = _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .FIELD_NAMES.PARTNER_AGE */ .mA.PARTNER_AGE;
var RELATIONSHIP = (_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1___default().RELATIONSHIP);
var mapWithIndex = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map);
var furtherConditionList = [
    AGE,
    INCOME_TIER,
    PARTNER_AGE
];
var submitUpdatedRefineFields = function(param) {
    var actions = param.actions, rebate = param.rebate, updatedFields = param.updatedFields, scale = param.scale;
    var scaleForPartnerAge = (updatedFields === null || updatedFields === void 0 ? void 0 : updatedFields.scale) || scale;
    mapWithIndex(function(value, key) {
        if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(key, furtherConditionList)) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            actions.customer["change".concat((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.upperFirst)(key))](value);
        }
        if (key === AGE) {
            var clientDateOfBirth = (0,_get_date_of_birth_from_age__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value);
            actions.customer.changeDateOfBirth(clientDateOfBirth, RELATIONSHIP.CLIENT);
        }
        if (key === HOSPITAL_EXCESS) {
            actions.customer.changeHospitalExcess(value);
        }
        if (key === INCOME_TIER && value !== _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .INCOME_TIER_NONE */ .yF) {
            actions.customer.changeRebate(true);
            actions.customer.changeIncomeTier(value);
        }
        if (key === INCOME_TIER && rebate === true && value === _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .INCOME_TIER_NONE */ .yF) {
            actions.customer.changeRebate(false);
        }
        if (key === PARTNER_AGE && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scaleForPartnerAge, _components_pricing_drawer_constants__WEBPACK_IMPORTED_MODULE_2__/* .SCALES_WITH_MULTIPLE_ADULTS */ .rn)) {
            var spouseDateOfBirth = (0,_get_date_of_birth_from_age__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value);
            actions.customer.changeDateOfBirth(spouseDateOfBirth, RELATIONSHIP.SPOUSE);
        }
    }, updatedFields);
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (submitUpdatedRefineFields);


/***/ })

}]);